import {DateTime} from 'luxon';

/**
 * Converts a UTC timestamp (in milliseconds) to local time by subtracting the local timezone offset.
 *
 * @param timestamp - A timestamp in UTC (milliseconds since epoch)
 * @returns The timestamp adjusted to local time, or `null` if input is `null`
 */
export function shiftUTCTimestampToLocal(timestamp: number | null): number | null {

    return timestamp
        ? timestamp - DateTime.local().offset * 60 * 1000
        : timestamp;
}

/**
 * Converts a local timestamp (in milliseconds) to UTC by adding the local timezone offset at that time.
 *
 * @param timestamp - A timestamp in local time (milliseconds since epoch)
 * @returns The timestamp adjusted to UTC, or `null` if input is `null`
 */
export function shiftLocalTimestampToUTC(timestamp: number | null): number | null {

    return timestamp
        ? timestamp + DateTime.fromMillis(timestamp).offset * 60 * 1000
        : timestamp;
}